import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {LiberarProduto}
 */
export default class LiberarProduto{

    constructor() {
        this.resource = "payment/makenocharge"

        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    liberar(product_id){       
        return this.http.post(`/`, {product_id:product_id});
    }

   /*liberar_periodo(params){
        return this.http.post('/save', params)
    }*/


}